module.exports = __webpack_public_path__ + "img/banner-2.3ae07206.jpg";